// src/utils/RatingChartConfig.js
const RatingChartConfig = (
  Response,
  xKey = 'label',
  colorMap = {
    star_1: '#EF4444', // Red
    star_2: '#F97316', // Orange
    star_3: '#EAB308', // Yellow
    star_4: '#22C55E', // Green
    star_5: '#3B82F6'  // Blue
  }
) => {
  console.log('Raw Response:', Response);

  // ✅ Handle both (res) or (res.data)
  const Datas =
    Array.isArray(Response?.data?.data)
      ? Response.data.data
      : Array.isArray(Response?.data)
        ? Response.data
        : Array.isArray(Response)
          ? Response
          : [];

  console.log('Parsed Datas:', Datas);
  console.log('Datas length:', Datas.length);

  // ✅ Use backend data or empty fallback
  const data =
    Datas.length > 0
      ? Datas
      : [];

  const useDataZoom = data.length > 20;
  const starKeys = ['star_1', 'star_2', 'star_3', 'star_4', 'star_5'];

  const series = starKeys.map((key, index) => ({
    name: `${index + 1} Star`,
    type: 'line',
    smooth: true,
    symbol: 'circle',
    symbolSize: 6,
    data: data.map(d => d[key] ?? 0),
    lineStyle: { color: colorMap[key], width: 2 },
    itemStyle: { color: colorMap[key] },
    areaStyle: {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          { offset: 0, color: `${colorMap[key]}99` },
          { offset: 1, color: `${colorMap[key]}00` }
        ]
      }
    },
    z: 5 - index
  }));

  return {
    color: Object.values(colorMap),

    // ✅ Tooltip with hover cross effect (X + Y)
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
          width: 1.5
        },
        label: {
          backgroundColor: '#6a7985',
          borderRadius: 4,
          padding: [3, 6],
          color: '#fff'
        }
      },
      formatter: params => {
        if (!params?.length) return '';
        const name = params[0]?.axisValue || '';
        const values = params.map(p => p.value ?? 0);
        const total = values.reduce((sum, v) => sum + v, 0);
        const avg = (total / values.length).toFixed(2);
        const rows = params
          .map(
            p =>
              `<span style="color:${p.color}">●</span> ${p.seriesName}: <b>${p.value}</b>`
          )
          .join('<br/>');

        return `
          <b>${name}</b><br/>
          ${rows}<br/>
          <hr style="margin:4px 0; border: none; border-top: 1px solid #ccc;" />
          ⭐ <b>Monthly Average:</b> ${avg}
        `;
      }
    },

    // ✅ Expanded width for better visual look
    grid: {
      left: '5%',          // more space at the sides
      right: '5%',         // balances both sides
      bottom: useDataZoom ? 80 : 60, // slightly increased bottom
      top: 40,
      containLabel: true
    },

    xAxis: {
      type: 'category',
      data: data.map(d => d[xKey]),
      boundaryGap: false,
      axisLabel: { interval: 0 },
      axisLine: { lineStyle: { width: 2 } } // slightly thicker line
    },

    yAxis: {
      type: 'value',
      name: 'Ratings Count',
      nameLocation: 'middle',
      nameGap: 40,
      splitLine: {
        show: true,
        lineStyle: { type: 'dashed', color: '#ddd' }
      },
      axisLine: { show: true },
      axisTick: { show: false }
    },

    dataZoom: useDataZoom
      ? [
        { type: 'inside', xAxisIndex: 0, start: 0, end: 40 },
        { type: 'slider', xAxisIndex: 0, height: 15, bottom: 40 }
      ]
      : [],

    series
  };
};

export default RatingChartConfig;
